
import { Create, SimpleForm, TextInput, DateInput, NumberInput } from 'react-admin';

export const Tbl_partitaCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput source="teamCasaId" />
            <NumberInput source="teamOspiteId" />
            <NumberInput source="legaStagioneId" />
            <NumberInput source="legaId" />
            <NumberInput source="stagioneId" />
            <DateInput source="data" />
            <DateInput source="ore" />
            <TextInput source="luogo" />
            <TextInput source="note" />
            <NumberInput source="flVisibile" />
            <NumberInput source="flAttivo" />
            <NumberInput source="flAnnullato" />
            <NumberInput source="ordinamento" />
            <DateInput source="createdAt" />
            <DateInput source="updatedAt" />
        </SimpleForm>
    </Create>
);
            